/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolCloudIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-cloud"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M6.4 20.75Q3.83 20.75 1.99 18.99Q0.15 17.23 0.15 14.65Q0.15 12.53 1.36 10.82Q2.58 9.13 4.6 8.55Q5.45 6.17 7.47 4.71Q9.5 3.25 12 3.25Q15.05 3.25 17.26 5.29Q19.48 7.33 19.75 10.43L19.75 10.43L19.75 10.43Q21.55 10.8 22.7 12.24Q23.85 13.68 23.85 15.55Q23.85 17.73 22.34 19.24Q20.82 20.75 18.65 20.75Z" fill={color} />
    </svg>
  );
}
